import { useAxios } from "../useAxios"
import { useAuthStore } from "../../../stores/auth/useAuthStore"


export const useHubspotWebhook = () => {
    const { sendRequest } = useAxios()

    const route = '/hub-spot'

    const getHubspotAccessToken = (payload?: any) => {
        return sendRequest({
            slug: 'get-hubspot-access-token',
            url: `${route}/access-token/me`,
            method: 'GET',
            payload
        })
    };

    const addHubspotAccessToken = (payload: any) => {
        console.log('payload', payload)
        return sendRequest({
            slug: 'add-hubspot-access-token',
            url: `${route}/access-token`,
            method: 'POST',
            payload
        })
    };

    const removeHubspotAccessToken = (id?: any) => {
        return sendRequest({
            slug: 'remove-hubspot-access-token',
            url: `${route}/access-token/${id}`,
            method: 'DELETE'
        })
    };

    const getHubspotTriggers = (payload?: any) => {
        return sendRequest({
            slug: 'get-hubspot-triggers',
            url: `${route}/triggers`,
            method: 'GET',
            payload: {
                page: 1,
                pageSize: 50,
                sort: 'newest',
                total: true
            }
        })
    };

    const addHubspotTrigger = (payload?: any) => {
        return sendRequest({
            slug: 'add-hubspot-trigger',
            url: `${route}/triggers`,
            method: 'POST',
            payload
        })
    };

    const editHubspotTrigger = (payload?: any) => {
        return sendRequest({
            slug: 'edit-hubspot-trigger',
            url: `${route}/triggers/${payload.id}`,
            method: 'PUT',
            payload: payload.body
        })
    };

    const removeHubspotTrigger = (id?: any) => {
        return sendRequest({
            slug: 'remove-hubspot-trigger',
            url: `${route}/triggers/${id}`,
            method: 'DELETE'
        })
    };

    // OAuth methods
    const getOAuthAuthorizationUrl = () => {
        return sendRequest({
            slug: 'get-hubspot-oauth-url',
            url: `${route}/oauth/authorize`,
            method: 'GET'
        })
    };

    const getOAuthStatus = () => {
        return sendRequest({
            slug: 'get-hubspot-oauth-status',
            url: `${route}/oauth/status`,
            method: 'GET'
        })
    };

    const reauthorizeWithOptionalScopes = () => {
        return sendRequest({
            slug: 'reauthorize-hubspot-oauth',
            url: `${route}/oauth/reauthorize`,
            method: 'GET'
        })
    };

    const disconnectOAuth = () => {
        return sendRequest({
            slug: 'disconnect-hubspot-oauth',
            url: `${route}/oauth/disconnect`,
            method: 'POST'
        })
    };

    const refreshOAuthToken = () => {
        return sendRequest({
            slug: 'refresh-hubspot-oauth-token',
            url: `${route}/oauth/refresh`,
            method: 'POST'
        })
    };

    const getContactProperties = () => {
        return sendRequest({
            slug: 'get-hubspot-contact-properties',
            url: `${route}/oauth/contact-properties`,
            method: 'GET'
        })
    };

    const saveFieldMappings = (payload: any) => {
        return sendRequest({
            slug: 'save-hubspot-field-mappings',
            url: `${route}/oauth/field-mappings`,
            method: 'POST',
            payload
        })
    };

    const getHubspotLists = (search?: string) => {
        return sendRequest({
            slug: 'get-hubspot-lists',
            url: `${route}/oauth/lists`,
            method: 'GET',
            params: search ? { search } : undefined
        })
    };

    const getHubspotWorkflows = () => {
        return sendRequest({
            slug: 'get-hubspot-workflows',
            url: `${route}/oauth/workflows`,
            method: 'GET'
        })
    };

    const getHubspotDealPipelines = () => {
        return sendRequest({
            slug: 'get-hubspot-deal-pipelines',
            url: `${route}/oauth/deal-pipelines`,
            method: 'GET'
        })
    };

    return {
        getHubspotAccessToken,
        addHubspotAccessToken,
        removeHubspotAccessToken,
        getHubspotTriggers,
        addHubspotTrigger,
        editHubspotTrigger,
        removeHubspotTrigger,
        // OAuth methods
        getOAuthAuthorizationUrl,
        getOAuthStatus,
        disconnectOAuth,
        refreshOAuthToken,
        reauthorizeWithOptionalScopes,
        // Field mapping methods
        getContactProperties,
        saveFieldMappings,
        // Lists, Workflows, Deals
        getHubspotLists,
        getHubspotWorkflows,
        getHubspotDealPipelines
    };
}